export function usePagination(filters) {
  const filter = ref("");

  const pagination = ref({
    sortBy: "",
    descending: false,
    page: 1,
    rowsPerPage: 0,
    rowsNumber: null,
  });

  const params = computed(() => {
    const keys = {
      search: filter.value || null,
      sortBy: pagination.value.sortBy || null,
      orderBy: null,
      page_size: pagination.value.rowsPerPage || null,
      offset:
        pagination.value.page - 1 < 0
          ? null
          : (pagination.value.page - 1) * pagination.value.rowsPerPage || null,
      ...unref(filters),
    };

    if (pagination.value.sortBy) {
      let orderBy = "asc";

      if (pagination.value.descending) {
        orderBy = "desc";
      }

      keys.orderBy = orderBy;
    }

    return keys;
  });

  return {
    filter,
    pagination,
    params,
  };
}
